<template>
    <div class="project-create-step relative flex flex-col gap-4 overflow-y-auto border-l-[1px] border-solid border-grey-40 p-4 pt-[60px]">
        <PtIcon icon="CopilotStep" class="absolute left-0 top-0 z-10 text-[120px]"></PtIcon>
        <CreateStep
            :createStepList="stepContent"
            :isStreamProcessing="isStreamProcessing"
            :streamStarting="streamStarting"
        />
    </div>
</template>

<script setup lang="ts">
import { PtIcon } from 'patsnap-biz';
import { useStep } from '@/composables/use-step';
import CreateStep from '@/components/create-step/CreateStep.vue';
import '@/assets/icons/copilot-step.svg'

const { updateStatus, analysis, stepContent, isStreamProcessing } = useStep()

defineExpose({
    updateStatus,
    analysis,
})
</script>
